export enum FreelanceJobSubSteps {
  MAIN = 'main',
  FREELANCE = 'freelance',
  GEWERBE = 'gewerbe',
  VOLUNTERING_INCOME = 'volunteering_income',
  VAT_DECLARATION = 'vatDeclaration',
}
